<template>
  <div class="details" :class="wrapperClass">
    <div
      v-for="(detail, idx) of details"
      :key="`section-${idx}`"
      :class="{ [sectionGutter]: details.length > 1 }"
    >
      <section-title v-if="detail.title" has-line :title="detail.title" />
      <div class="row mx-0">
        <div
          v-for="(info, index) of mappedInfo(detail)"
          :key="`info-${index}`"
          :class="`${info.class} ${colGutter}`"
        >
          <span class="data-title" :class="info.labelClass">
            {{ info.label }}
          </span>
          <span :class="info.dataClass">{{ info.data }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import { capitalize, date } from '@/utils/filters';

export default {
  name: 'DetailGenerator',
  components: { SectionTitle },
  props: {
    wrapperClass: {
      type: [String, Object],
      default: () => '',
    },
    details: {
      type: Array,
      default: () => [],
    },
    colGutter: {
      type: String,
      default: () => 'mb-2 mb-md-0',
    },
    sectionGutter: {
      type: String,
      default: () => 'mb-4',
    },
  },
  computed: {
    mappedInfo() {
      return ({ info }) =>
        info
          ?.map((d) => {
            (d.filters || []).forEach((filter) => {
              switch (filter) {
                case 'date':
                  d.data = date(d.data);
                  break;
                case 'capitalize':
                  d.data = capitalize(d.data);
                  break;
              }
            });
            return { ...d, data: d.data || '--' };
          })
          .filter((d) => !d.hidden);
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  .data-title {
    display: block;
  }
}
</style>
